export type HomeMode = 'assistant' | 'spaces';

const SELECTED_PROJECTS_KEY = 'arch-editor.assistant.selectedProjectIds';
const SELECTED_PROVIDER_KEY = 'arch-editor.assistant.providerId';
const HOME_MODE_KEY = 'arch-editor.home.mode';

export function getAssistantSelectedProjectIds(): string[] {
  const raw = window.localStorage.getItem(SELECTED_PROJECTS_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function hasAssistantSelectedProjectIds(): boolean {
  return window.localStorage.getItem(SELECTED_PROJECTS_KEY) !== null;
}

export function setAssistantSelectedProjectIds(projectIds: string[]): void {
  window.localStorage.setItem(SELECTED_PROJECTS_KEY, JSON.stringify(Array.from(new Set(projectIds))));
}

export function getAssistantProviderId(): string {
  return window.localStorage.getItem(SELECTED_PROVIDER_KEY) || '';
}

export function setAssistantProviderId(providerId: string): void {
  if (!providerId) {
    window.localStorage.removeItem(SELECTED_PROVIDER_KEY);
    return;
  }
  window.localStorage.setItem(SELECTED_PROVIDER_KEY, providerId);
}

export function getHomeMode(): HomeMode {
  return window.localStorage.getItem(HOME_MODE_KEY) === 'spaces' ? 'spaces' : 'assistant';
}

export function setHomeMode(mode: HomeMode): void {
  window.localStorage.setItem(HOME_MODE_KEY, mode);
}
